import { useContext, useEffect } from 'react';
import { ReactReduxContext } from 'react-redux';
import {
  setContactButtonDefaultTriggerEnabled,
  setContactButtonIsHidden
} from '../actions/contactButton';
import { isOnServer } from '~/helpers/isOnServer';

/**
 * @description This hook will hide the contactButton when being rendered.
 *
 * @returns void
 */
export const useHideContactButtonEffect = () => {
  const {
    store: { dispatch }
  } = useContext(ReactReduxContext);

  useEffect(() => {
    dispatch(setContactButtonDefaultTriggerEnabled(false));
    dispatch(setContactButtonIsHidden(true));

    return () => {
      dispatch(setContactButtonDefaultTriggerEnabled(true));
      dispatch(setContactButtonIsHidden(false));
    };
  }, [dispatch]);

  if (isOnServer) {
    dispatch(setContactButtonDefaultTriggerEnabled(false));
    dispatch(setContactButtonIsHidden(true));
  }
};
